import Immutable from 'seamless-immutable';
import { SERVICE_ACCESSES } from '@common/constants';
import { ACTIONS } from './actions';

export const initialState = Immutable.from({
  member: {
    companySearchInput: '',
    companyCreateError: false,
    roleSearchInput: '',
    selectedCompany: null,
    selectedRole: null,
    selectedAccessLevel: { value: SERVICE_ACCESSES.MEMBER },
  },
  subscription: {
    currentOfferings: null,
    currentOperation: {
      category: null,
      categoryName: null,
      licensingModel: null,
      plc: null,
      type: null,
      saved: false,
      error: false,
      assignAfterOperation: false,
    },
  },
  save: false,
});

export const reducer = (state, action) => {
  switch (action.type) {
    case ACTIONS.SET_COMPANY:
      return state.merge(
        {
          member: {
            selectedCompany: action.payload.value,
            companyCreateError: false,
          },
          save: action.payload.save || false,
        },
        { deep: true }
      );
    case ACTIONS.SET_COMPANY_CREATE_ERROR:
      return state.merge(
        {
          member: { companyCreateError: action.payload.value },
        },
        { deep: true }
      );
    case ACTIONS.SET_COMPANY_SEARCH_INPUT:
      return state.merge(
        {
          member: { companySearchInput: action.payload.value },
        },
        { deep: true }
      );
    case ACTIONS.SET_ROLE:
      return state.merge(
        {
          member: { selectedRole: action.payload.value },
          save: action.payload.save || false,
        },
        { deep: true }
      );
    case ACTIONS.SET_ROLE_SEARCH_INPUT:
      return state.merge(
        {
          member: { roleSearchInput: action.payload.value },
        },
        { deep: true }
      );
    case ACTIONS.SET_ACCESS_LEVEL:
      return state.merge(
        {
          member: { selectedAccessLevel: action.payload.value },
          save: action.payload.save || false,
        },
        { deep: true }
      );
    case ACTIONS.SET_SAVE:
      return state.set('save', action.payload);
    case ACTIONS.SET_LICENSE_OPERATION:
      return state.merge(
        {
          subscription: {
            currentOperation: {
              category: action.payload.category,
              categoryName: action.payload.categoryName,
              licensingModel: action.payload.licensingModel,
              type: action.payload.type,
              plc: action.payload.plc,
              saved: action.payload.saved,
              error: action.payload.error,
              assignAfterOperation: action.payload.assignAfterOperation,
            },
          },
        },
        { deep: true }
      );
    case ACTIONS.SET_OFFERINGS:
      return state.merge(
        {
          subscription: {
            currentOfferings: action.payload,
          },
        },
        { deep: true }
      );
    case ACTIONS.SET_SELECTED_OFFERING:
      return state.setIn(
        [
          'subscription',
          'currentOfferings',
          action.payload.category,
          'selectedOffering',
        ],
        action.payload.offering
      );
    case ACTIONS.RESET_SUBSCRIPTION_DATA:
      return state.merge(
        {
          subscription: initialState.subscription,
        },
        { deep: true }
      );
    default:
      return state;
  }
};
